import { useEffect, useState, useContext, useRef } from "react";
import { useNavigate, useParams } from "react-router";
import axios from 'axios';
import SignaturePad from 'signature_pad';

import { AppContext } from '../../context.js';

function Signature() {
  const context = useContext(AppContext);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [penColor, setPenColor] = useState("black");
  const [backgroundColor, setBackgroundColor] = useState("rgba(0,0,0,0)");

  const canvasRef = useRef(null);
  const signaturePadRef = useRef(null);

  useEffect(() => {
    if (canvasRef.current) {
      // Initialize SignaturePad
      signaturePadRef.current = new SignaturePad(canvasRef.current, {
        backgroundColor: backgroundColor,
        penColor: penColor,
        minWidth: 0.5,
        maxWidth: 2.5,
        throttle: 16,
        minDistance: 5,
      });

      // Handle canvas resize for high DPI screens
      const resizeCanvas = () => {
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        const canvas = canvasRef.current;
        
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext("2d").scale(ratio, ratio);
        
        signaturePadRef.current.clear();
      };

      // Initial resize
      resizeCanvas();

      // Listen for window resize
      window.addEventListener("resize", resizeCanvas);

      // Event listeners
      signaturePadRef.current.addEventListener("beginStroke", () => {
        console.log("Signature started");
      });

      signaturePadRef.current.addEventListener("endStroke", () => {
        console.log("Signature ended");
      });

      return () => {
        window.removeEventListener("resize", resizeCanvas);
        if (signaturePadRef.current) {
          signaturePadRef.current.off();
        }
      };
    }
  }, [backgroundColor, penColor]);

  const clearSignature = () => {
    if (signaturePadRef.current) {
      signaturePadRef.current.clear();
    }
  };

  const undoSignature = () => {
    if (signaturePadRef.current) {
      const data = signaturePadRef.current.toData();
      if (data.length > 0) {
        data.pop(); // Remove the last stroke
        signaturePadRef.current.fromData(data);
      }
    }
  };

  const saveAsPNG = () => {
    if (signaturePadRef.current && !signaturePadRef.current.isEmpty()) {
      const dataURL = signaturePadRef.current.toDataURL();
      const link = document.createElement('a');
      link.download = 'signature.png';
      link.href = dataURL;
      link.click();
    } else {
      alert('Please provide a signature first.');
    }
  };

  const saveAsJPEG = () => {
    if (signaturePadRef.current && !signaturePadRef.current.isEmpty()) {
      const dataURL = signaturePadRef.current.toDataURL("image/jpeg", 0.8);
      const link = document.createElement('a');
      link.download = 'signature.jpg';
      link.href = dataURL;
      link.click();
    } else {
      alert('Please provide a signature first.');
    }
  };

  const saveAsSVG = () => {
    if (signaturePadRef.current && !signaturePadRef.current.isEmpty()) {
      const svgString = signaturePadRef.current.toSVG();
      const blob = new Blob([svgString], { type: 'image/svg+xml' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.download = 'signature.svg';
      link.href = url;
      link.click();
      URL.revokeObjectURL(url);
    } else {
      alert('Please provide a signature first.');
    }
  };

  if (loading) {
    return (
      <></>
    );
  } 

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-lg-8 col-lg-offset-2">

          <div style={{paddingTop: "20px"}} />

          <div className="card">
            <div className="card-header text-center">
              <div className="typo-strong-200">Signature Pad Example</div>

              {/* Canvas for signature */}
              <div style={{ 
                border: "1px solid #000", 
                margin: "20px auto", 
                width: "100%", 
                maxWidth: "600px",
                borderRadius: "8px"
              }}>
                <canvas
                  ref={canvasRef}
                  style={{ 
                    width: "100%", 
                    height: "300px",
                    display: "block",
                    borderRadius: "6px"
                  }}
                />
              </div>

              {/* Control buttons */}
              <div>
                <div className="item grey typo-normal-150 me-2" onClick={clearSignature}>Clear</div>
                <div className="item grey typo-normal-150 me-2" onClick={undoSignature}>Undo</div>
                <div className="item grey typo-normal-150 me-2" onClick={saveAsPNG}>Save as PNG</div>
                <div className="item grey typo-normal-150 me-2" onClick={saveAsJPEG}>Save as JPEG</div>
                <div className="item grey typo-normal-150 me-2" onClick={saveAsSVG}>Save as SVG</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Signature;
